var _rect, _g, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCartLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_726_10381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 18,
    width: 36,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 36,
    height: 36,
    fill: "#D4AF37"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_726_10381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5 51C27.675 51 26.9688 50.7063 26.3813 50.1188C25.7938 49.5312 25.5 48.825 25.5 48C25.5 47.175 25.7938 46.4688 26.3813 45.8812C26.9688 45.2937 27.675 45 28.5 45C29.325 45 30.0312 45.2937 30.6187 45.8812C31.2063 46.4688 31.5 47.175 31.5 48C31.5 48.825 31.2063 49.5312 30.6187 50.1188C30.0312 50.7063 29.325 51 28.5 51ZM43.5 51C42.675 51 41.9688 50.7063 41.3813 50.1188C40.7938 49.5312 40.5 48.825 40.5 48C40.5 47.175 40.7938 46.4688 41.3813 45.8812C41.9688 45.2937 42.675 45 43.5 45C44.325 45 45.0312 45.2937 45.6188 45.8812C46.2063 46.4688 46.5 47.175 46.5 48C46.5 48.825 46.2063 49.5312 45.6188 50.1188C45.0312 50.7063 44.325 51 43.5 51ZM25.8 24H47.925C48.5 24 48.9375 24.2563 49.2375 24.7688C49.5375 25.2812 49.55 25.8 49.275 26.325L43.95 35.925C43.675 36.425 43.3062 36.8125 42.8438 37.0875C42.3813 37.3625 41.875 37.5 41.325 37.5H30.15L28.5 40.5H46.5V43.5H28.5C27.375 43.5 26.525 43.0063 25.95 42.0187C25.375 41.0312 25.35 40.05 25.875 39.075L27.9 35.4L22.5 24H19.5V21H24.375L25.8 24Z",
    fill: "#5B5B5B"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35,
    stroke: "#676767",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartLogo);
export default __webpack_public_path__ + "static/media/cartLogo.452ae20fd5a2a9c6200598a22030c49d.svg";
export { ForwardRef as ReactComponent };